export function getTime(createdOn) {
  if (!createdOn) return "";
  const date = new Date(createdOn);
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  if (diffInSeconds < 0) return "Just now";

  const minutes = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(diffInSeconds / 3600);
  const days = Math.floor(diffInSeconds / 86400);
  const weeks = Math.floor(diffInSeconds / 604800);
  const months = Math.floor(diffInSeconds / 2629800);
  const years = Math.floor(diffInSeconds / 31557600);

  if (diffInSeconds < 1) return "just now";
  if (diffInSeconds < 60)
    return `${diffInSeconds} sec${diffInSeconds !== 1 ? "s" : ""} ago`;
  if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
  if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
  if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
  return `${years} year${years !== 1 ? "s" : ""} ago`;
}

export function canSeeCounts(createdOn, CAN_SEE_COUNTS) {
  if (!createdOn) return false;
  const date = new Date(createdOn);
  if (isNaN(date.getTime())) return false;

  const now = new Date();
  const diffInMinutes = (now - date) / (1000 * 60);
  return diffInMinutes >= CAN_SEE_COUNTS;
}
